import { Controller } from "@hotwired/stimulus"
import { showToast } from "./toast"

export default class extends Controller {
  static targets = ["photo", "placeholder", "actions", "searchButton", "generateButton"]
  static values = {
    searchUrl: String,
    generateUrl: String
  }

  async search(event) {
    event.preventDefault()
    await this.requestImage(this.searchUrlValue, this.searchButtonTarget, "Searching...")
  }

  async generate(event) {
    event.preventDefault()
    await this.requestImage(this.generateUrlValue, this.generateButtonTarget, "Generating...")
  }

  async requestImage(url, button, loadingLabel) {
    if (!url) {
      showToast("Image lookup not configured")
      return
    }

    const originalLabel = button.textContent
    button.disabled = true
    button.textContent = loadingLabel

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({})
      })

      const data = await response.json()

      if (response.ok && data.image_url) {
        this.setPhoto(data.image_url)
      } else {
        showToast(data.error || "Could not find an image")
      }
    } catch (error) {
      console.error("Author image error:", error)
      showToast("An error occurred while fetching the image")
    } finally {
      button.disabled = false
      button.textContent = originalLabel
    }
  }

  setPhoto(url) {
    if (this.hasPhotoTarget) {
      this.photoTarget.src = url
      this.photoTarget.classList.remove("hidden")
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }

    if (this.hasActionsTarget) {
      this.actionsTarget.classList.add("hidden")
    }
  }
}
